<template>
  <div>
    <FormEditorVisitorEditorModal 
      :id="selected_visitor_id"
      ref="visitor-modal"
    />
      
      <m-row class="mt-4">
        <m-col lg="6">
          <memlist-datetime-picker
            class="mt-8"
            :label="$t('EVENT.START_TIME')"
            v-model="local_item.from_datetime"
            @input="on_change"
          />

        </m-col>
        <m-col lg="6">
          
        </m-col>
      </m-row>
      
      

      <memlist-static-table
        id="visitors-table"
        style="width: 100%; table-layout: fixed;"
        class="table-striped mt-8"
        :fields="visitors_headers"
        :items="visitors_items"
        head-variant="light"
        ref="visitors-table"
      >
        <template #cell(actions)="data">

          <div class='d-flex justify-content-end'>
            <memlist-table-button @click="edit_visitor_clicked(data.item)" class="mr-2" svg="/assets/svg/pencil-square.svg" :tooltip="$t('COMMON.EDIT')" />
            <memlist-table-button @click="delete_visitor_clicked(data.item)" svg="/assets/svg/trash2.svg" :tooltip="$t('COMMON.DELETE')" />
          </div>
        </template>

      </memlist-static-table>

      <Confirm
        :title="$t('EVENT.TICKET.DELETE_TICKET')"
        :message="$t('EVENT.TICKET.DELETE_TICKET_INFO')"
        ref="delete-ticket"
        :type="'success'"
        :confirm="$t('COMMON.YES')"
        :cancel="$t('COMMON.NO')"
        @confirm="delete_ticket_confirm"
      />
    </div>
  </div>
</template>

<script>
import { get_base_url, downloadWithAxios } from '@/core/services/fileDownload';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import axios from 'axios';
import dayjs from 'dayjs';
import FormEditorVisitorEditorModal from './FormEditorVisitorEditorModal.vue'

export default {
  name: 'FormEditorVisitorsTable',
  props: ['item'],
  mixins: [ toasts ],
  components: {
    FormEditorVisitorEditorModal
  },
  computed: {
    
  },
  watch: {

    item: {
      deep: true,
      handler(val) {
        this.local_item = { ...this.item };

        if (this.local_item.id) {
          this.load_visitors(this.local_item.id);
        }

      },
      immediate: true
    },
    
  },
  data() {
    return {
      selected_visitor_id: null,
      
      visitors_items: [],

      visitors_headers: [
        {
          key: 'visitor_id',
          label: this.$t('FORM.VISITOR.VISITOR_ID'),
          sortable: true,
          thClass: 'pl-7 align-middle',
          tdClass: 'pl-7'
        },
        {
          key: 'first_created_at',
          label: this.$t('FORM.VISITOR.CREATED_AT'),
          sortable: true,
          thClass: 'w-150px align-middle',
          tdClass: 'w-150px',
          formatter: (_, __, item) => {
            return dayjs(item.first_created_at).format('YYYY-MM-DD HH:mm');
          }
        },
        
        {
          key: 'actions',
          label: this.$t('COMMON.ACTIONS'),
          thClass: 'text-right',
        },
      ],

      local_item: {}
    }
  },
  methods: {

    edit_visitor_clicked(item) {
      this.selected_visitor_id = item.visitor_id;
      this.$refs['visitor-modal'].show();
    },
    delete_visitor_clicked(item) {
      this.delete_visitor(item.visitor_id);

      const index = this.visitors_items.findIndex(i => i.visitor_id === item.visitor_id);

      this.visitors_items.splice(index, 1);
    },

    async load_visitors(form_id) {
      const res = await axios.get(`/form/visitors/${form_id}`);

      if (res.status === 200) {
        this.visitors_items = res.data;
      }
    },


    async delete_visitor(id) {
      try {
        const res = await axios.delete(`/form/visitor/${id}`);

        if (res.status === 204) {
          this.toastr('success', this.$t('COMMON.SUCCESS'), this.$t('FORM.VISITOR.DELETED'));
          
          return;
        }

        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('FORM.VISITOR.UNABLE_DELETE'));
      }
      catch (err) {
        console.error(err);
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('FORM.VISITOR.UNABLE_DELETE'));
      }
    },


  }
}
</script>
<style scoped>
.empty-participant-message {
  text-align: center;
  padding: 4rem 1rem;
  background: #f9f9f9;
  border: 1px dashed #ccc;
  border-radius: 8px;
}

.big-icon {
  font-size: 4rem;
  color: #2D9BF0;
  margin-bottom: 1rem;
}

.info-text {
  font-size: 1.2rem;
  color: #555;
}
</style>